import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  /**
   * Standard Angular Constructor
   *
   * @ignore
   */
  constructor(
    /* eslint-disable */
    private sanitized: DomSanitizer
    /* eslint-enable */
  ) {}

  /**
   * Sanitises and retuns unsafe html.
   *
   * @arg {any} value The html that needs to be sanitised.
   * @return {any} The sanitised html.
   */
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

}
